import { HttpResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { Constants } from '../app.constants';
import { AppService } from '../app.service';
import { StorageService } from '../app.storage.service';

@Component({
  selector: 'app-account-creation',
  templateUrl: './account-creation.component.html',
  styleUrls: ['../../assets/css/account-creation-custom.css', 
            '../../assets/css/account-creation-sidePanel.css',
            'account-creation.component.css']
})
export class AccountCreationComponent {
    constructor(private storageService: StorageService,
                private appService: AppService
      ){

    }
    userData: any = null;
    userName: any = null;
    profilePic: string = null;
    profilePicObj: any = null;
    imageViewUrl: string = Constants.IMAGE_BASE_URL;
    steps: any[] = [];
    stepsSubscription: Subscription;
    newAccount: any;

    navigationPage: string  = null;
    navigationPageSubscription: Subscription;

  ngOnInit() {

    this.navigationPageSubscription = this.appService.workmateAppLinkSubject.subscribe((data)=>{
      if(data){
        this.navigationPage = data;
      }
    })

    var userData = this.storageService.getDataFromLocalStorage(Constants.STORAGE_KEY.USER_INFO);
    this.newAccount = this.storageService.getDataFromLocalStorage(Constants.STORAGE_KEY.NEW_ACCOUNT);
    // console.log(userData)
    if (userData) {
      this.userData = userData;
      this.userName = userData.name;
    }else{
      let newUserInfo = this.storageService.getDataFromLocalStorage("newUserInfo");
      if(newUserInfo){
        this.userName = newUserInfo.name;
        this.profilePic = newUserInfo.profile;
      }
    }


    let accessToken = this.storageService.getDataFromLocalStorage("getStartedAccessToken")

    if (this.storageService.getDataFromLocalStorage("steps")) {
      let steps = this.storageService.getDataFromLocalStorage("steps");
      this.appService.stepsSubject.next(steps);
    } else {
      let steps = [1];
      this.storageService.setDataInLocalStorage("steps", steps);
      this.appService.stepsSubject.next(steps);
    }

    this.stepsSubscription = this.appService.stepsSubject.subscribe((data)=>{
     // console.log(data);
      if(this.storageService.getDataFromLocalStorage("steps")){
        this.steps = this.storageService.getDataFromLocalStorage("steps");
      }
    })

    // this.getProfilePicture();
  } 

  ngOnDestroy(){
    if(this.stepsSubscription){
      this.stepsSubscription.unsubscribe();
    }
    if(this.navigationPageSubscription){
      this.navigationPageSubscription.unsubscribe();
    }
  }

  isEnableTab(tabId){
    if(this.steps){
      return this.steps.includes(tabId);
    }
  }


    getProfilePicture(){
      this.appService.getProfilePicture()
        .subscribe((res: HttpResponse<any>)=>{
          this.profilePic = null;
          if(res.body.profilePicture && res.body.profilePicture.docId){
            this.profilePicObj = res.body.profilePicture;
            this.profilePic = res.body.profilePicture.docId;
          }
        }, (err)=>{
  
        })
    }

    logout(){
      this.storageService.clearStorage();
      window.location.href=Constants.LOGIN_URL;
    }


}
